import { escapeHtml } from "./geozoneFeatureInfo";

// Leaflet-freier Bauer für das ED-269-Geozonen-Popup-HTML. Ausgelagert aus
// ed269Web.ts (das leaflet importiert und daher unter dem tsx-Test-Runner nicht
// ladbar ist), damit die Quellen-Gating-Logik testbar bleibt:
//
//   sourceLabel === ""  =>  KEIN Quellen-Hinweis im Popup (normaler Pilot)
//   sourceLabel !== ""  =>  Quellen-Hinweis sichtbar (Admin)
//
// Siehe web/src/lib/__tests__/sourceAttributionWeb.test.ts.

export interface Ed269PopupLink {
  label: string;
  url: string;
}

export interface Ed269PopupData {
  name: string;
  // Leerer String => Quellenangabe wird unterdrückt (nur Admins sehen sie).
  sourceLabel: string;
  restrictionLabel: string;
  altitude: string;
  detail?: string;
  appText?: string;
  links?: Ed269PopupLink[];
  // Wenn gesetzt, wird im Popup ein Button gerendert (data-ed269-focus), über den
  // die Planungs-Karte eine isolierte Einzel-Zonen-Ansicht öffnet. Leer/undef =>
  // kein Button (Standard-Verhalten der großen Karte MapPage).
  focusButtonLabel?: string;
}

export function buildEd269PopupHtml(d: Ed269PopupData): string {
  const detail = (d.detail || "").toString().trim();
  const detailHtml = detail
    ? `<br/><span style="font-size:12px;white-space:pre-line">${escapeHtml(detail)}</span>`
    : "";

  // Antrags-/Genehmigungs-Hinweise mit anklickbaren Links. target="_blank" +
  // rel für sichere externe Links; E-Mail-Adressen werden zu mailto:.
  const linkRows: string[] = [];
  for (const link of d.links ?? []) {
    const u = (link?.url || "").toString().trim();
    const l = (link?.label || "").toString().trim();
    if (!u || !l) continue;
    const isMail = /@/.test(u) && !/^https?:/i.test(u);
    const href = isMail ? `mailto:${u}` : u;
    linkRows.push(
      `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer" style="font-size:12px;color:#2563eb;font-weight:600;text-decoration:none">${escapeHtml(l)}</a>`,
    );
  }
  const appText = (d.appText || "").toString().trim();
  const appHtml =
    appText || linkRows.length > 0
      ? `<div style="margin-top:6px;padding-top:6px;border-top:1px solid #e2e8f0">` +
        (appText ? `<div style="font-size:12px;line-height:1.4">${escapeHtml(appText)}</div>` : "") +
        (linkRows.length > 0
          ? `<div style="margin-top:4px;display:flex;flex-direction:column;gap:3px">${linkRows.join("")}</div>`
          : "") +
        `</div>`
      : "";

  const focusLabel = (d.focusButtonLabel || "").toString().trim();
  const focusHtml = focusLabel
    ? `<button type="button" data-ed269-focus style="margin-top:8px;width:100%;padding:6px 8px;border:1px solid #2563eb;border-radius:6px;background:#eff6ff;color:#2563eb;font-size:12px;font-weight:600;cursor:pointer">${escapeHtml(focusLabel)}</button>`
    : "";

  return (
    `<div style="max-width:260px">` +
    `<b>${escapeHtml(d.name)}</b><br/>` +
    (d.sourceLabel
      ? `<span style="font-size:12px;color:#475569">${escapeHtml(d.sourceLabel)}</span><br/>`
      : "") +
    `<span style="font-size:12px"><b>Beschränkung:</b> ${escapeHtml(d.restrictionLabel)}</span><br/>` +
    `<span style="font-size:12px"><b>Höhe:</b> ${escapeHtml(d.altitude)}</span>` +
    detailHtml +
    appHtml +
    focusHtml +
    `</div>`
  );
}
